import React from 'react'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface GrowthWheelPaginationProps {
    currentIndex: number
    optionsList: Array<{ id: number; name: string }>
    handleClickPrevious: (index: number) => void
    handleClickNext: (index: number) => void
    type: 'Competency' | 'Sub-competency'
}

const GrowthWheelPagination = ({ currentIndex, optionsList, handleClickPrevious, handleClickNext, type }: GrowthWheelPaginationProps) => {
    const previous = optionsList[currentIndex - 1]
    const next = optionsList[currentIndex + 1]
    return (
        <div className="card shadow-sm gw-competency-footer">
            <div className="gw-competency-footer-content">
                <button style={{ padding: '18px 18px 18px 22px' }} className="gw-competency-footer-button" type="button" disabled={currentIndex === 0} onClick={() => handleClickPrevious(currentIndex - 1)}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                    {previous?.name ?? `Previous ${type}`}
                </button>
                <div className="gw-competency-footer-dots">
                    {optionsList.map((option, index) => (
                        <span className={`gw-competency-footer-dot ${index === currentIndex ? 'gw-competency-footer-dot--active' : ''}`} key={option.id} />
                    ))}
                </div>
                <button style={{ padding: '18px 22px 18px 18px' }} className="gw-competency-footer-button" type="button" disabled={currentIndex === optionsList.length - 1} onClick={() => handleClickNext(currentIndex + 1)}>
                    {next?.name ?? `Next ${type}`}
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </div>
        </div>
    )
}

export default GrowthWheelPagination